import { set } from "shelljs";

export default {
  login_in(state, res) {
    state.userToken = res.userToken;
    state.refreshToken = res.refreshToken;
    state.refreshTokenExpireTime = res.refreshTokenExpireTime;

    localStorage.userToken = res.userToken;
    localStorage.startTime = Date.parse(new Date())
    sessionStorage.userToken = res.userToken;
    sessionStorage.refreshToken = res.refreshToken;
    sessionStorage.refreshTokenExpireTime = res.refreshTokenExpireTime;
  },
  userInfo(state, res) {

    state.enterpriseId = res.id;
    state.sysUserName = res.sysUserName;
    state.role = res.role;
    state.resources = res.resources;

    sessionStorage.setItem('resources', res.resources);
    sessionStorage.setItem('roleLv', res.role);
    sessionStorage.sysUserName = res.sysUserName;
    sessionStorage.enterpriseId = res.id;
  },
  setItemArr(state, res) {
    state.itemArr = res
  },
  setSaveStste(state, res) {
    state.SaveStste = res
  },
  SetTemplateMarket(state, res) {
    state.templateMarket = res
  },
  SetRouter(state, res) {
    state.userRouter = res
    localStorage.userRouter = JSON.stringify(res)
  },
  setBtnRole(state, res) {
    state.btnList = res
    localStorage.btnList = JSON.stringify(res)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js